import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ConsultingPhysician.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

export default function ConsultingPhysician() {
  const navigate = useNavigate();
  const [currentDate] = useState('8 tháng 4, 2025');
  const [currentDay] = useState('Thứ Tư');

  // Handler functions
  const handlePreviousStep = () => {
    alert('Chuyển đến bước tư vấn trước...');
  };

  const handleNextStep = () => {
    alert('Chuyển đến bước tư vấn tiếp theo...');
  };

  const handleShowInfo = () => {
    alert('Hiển thị thông tin tư vấn...');
  };

  const handleToggleCamera = () => {
    alert('Bật/tắt camera...');
  };

  const handleEndCall = () => {
    if (window.confirm('Bạn có chắc chắn muốn kết thúc cuộc tư vấn?')) {
      navigate('/appointment-calendar');
    }
  };

  const handleShowDetails = () => {
    alert('Hiển thị thông tin chi tiết...');
  };

  const handleExpandDetails = () => {
    alert('Mở rộng bảng chi tiết...');
  };

  const handleAddNote = () => {
    alert('Thêm ghi chú tư vấn...');
  };

  const handleLike = () => {
    alert('Đánh dấu là hữu ích...');
  };

  const handleComment = () => {
    alert('Thêm bình luận...');
  };

  const handleCopy = () => {
    alert('Sao chép thông tin...');
  };

  return (
    <div className="consulting-physician-page page-with-header">
      <Header />
      
      <div className="consulting-physician-container">
        {/* Main Dashboard */}
        <div className="dashboard-grid">
          {/* Left Column - Main Video */}
          <div className="left-column">
            <div className="main-video-container">
              <div className="patient-video-main">
                <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800&h=600&fit=crop&crop=face" alt="Bệnh nhân" />
                
                {/* Facial Tracking Overlay */}
                <div className="facial-tracking-overlay">
                  {/* Face outline polygon */}
                  <svg className="face-outline" viewBox="0 0 400 300">
                    <polygon 
                      points="120,80 280,80 320,120 310,200 280,240 200,260 120,240 90,200 80,120" 
                      fill="none" 
                      stroke="#ff6b35" 
                      strokeWidth="2"
                      opacity="0.8"
                    />
                    {/* Tracking points */}
                    <circle cx="150" cy="120" r="3" fill="#ff6b35" />
                    <circle cx="250" cy="120" r="3" fill="#ff6b35" />
                    <circle cx="180" cy="140" r="3" fill="#ff6b35" />
                    <circle cx="220" cy="140" r="3" fill="#ff6b35" />
                    <circle cx="200" cy="160" r="3" fill="#ff6b35" />
                    <circle cx="200" cy="190" r="3" fill="#ff6b35" />
                  </svg>
                </div>

                {/* Doctor Info Overlay */}
                <div className="doctor-info-overlay">
                  <h4>Bác sĩ Phạm Minh Đức</h4>
                  <p>Nhà tâm lý học, Chuyên gia trị liệu</p>
                </div>

                {/* Instructions Section */}
                <div className="instructions-overlay">
                  <h5>Hướng dẫn từ AI</h5>
                  <div className="instruction-text">
                    <i className="fas fa-microphone"></i>
                    <span>Nâng <span className="highlight">lông mày cao nhất có thể</span> trong khi nhấn <span className="highlight">"nhẹ nhàng"</span></span>
                  </div>
                </div>

                {/* Video Controls */}
                <div className="video-controls-overlay">
                  <button className="control-btn secondary" onClick={handlePreviousStep}>Trước</button>
                  <button className="control-btn primary" onClick={handleNextStep}>Tiếp theo</button>
                </div>
              </div>

              {/* Small Video Call Window */}
              <div className="small-video-call">
                <div className="small-video">
                  <img src="https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=200&h=150&fit=crop&crop=face" alt="Bác sĩ" />
                </div>
                <div className="call-controls">
                  <button className="call-btn info" onClick={handleShowInfo}><i className="fas fa-info-circle"></i></button>
                  <button className="call-btn camera" onClick={handleToggleCamera}><i className="fas fa-video"></i></button>
                  <button className="call-btn end" onClick={handleEndCall}><i className="fas fa-phone-slash"></i></button>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="right-column">
            {/* Date Header */}
            <div className="date-header">
              <div className="user-badge">
                <span className="user-initial">X</span>
                <div className="user-info">
                  <span className="user-name">Nguyễn Văn A</span>
                  <span className="user-plan">Kế hoạch hành động</span>
                </div>
              </div>
              <div className="date-info">
                <span className="date">{currentDate}</span>
                <span className="day">{currentDay}</span>
              </div>
            </div>

            {/* Assessment Card */}
            <div className="assessment-card">
              <div className="assessment-header">
                <i className="fas fa-clipboard-check"></i>
                <span>Đánh giá</span>
              </div>
              <div className="assessment-content">
                <div className="brain-visual">
                  <div className="brain-model">
                    <img src="https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=200&h=150&fit=crop" alt="Mô hình não bộ" />
                    <div className="analysis-indicators">
                      <div className="indicator red" style={{top: '30%', left: '40%'}}></div>
                      <div className="indicator orange" style={{top: '60%', right: '35%'}}></div>
                    </div>
                  </div>
                  <div className="treatment-text">
                    <h4>Điều trị tâm lý</h4>
                    <p>Các liệu pháp như CBT hoặc chánh niệm giúp quản lý căng thẳng</p>
                    <button className="details-btn" onClick={handleShowDetails}>Chi tiết</button>
                  </div>
                </div>
                <button className="expand-arrow" onClick={handleExpandDetails}>
                  <i className="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>

            {/* Test Results Grid */}
            <div className="test-results-grid">
              <div className="test-card lab-tests">
                <div className="test-icon">
                  <i className="fas fa-flask"></i>
                </div>
                <div className="test-content">
                  <div className="test-header">
                    <span className="test-title">Xét nghiệm</span>
                    <span className="test-subtitle">2 xét nghiệm đã lên lịch</span>
                  </div>
                  <div className="test-details">
                    <div className="test-type">Điều trị tâm lý</div>
                    <div className="test-name">Kiểm tra</div>
                    <div className="test-method">NCCT</div>
                    <div className="test-scan">Quét</div>
                    <div className="download-progress">
                      <span>Đang tải xuống</span>
                      <div className="progress-bar">
                        <div className="progress-fill" style={{width: '70%'}}></div>
                      </div>
                      <span className="percentage">70%</span>
                    </div>
                  </div>
                  <div className="file-icons">
                    <i className="fas fa-file-alt"></i>
                    <i className="fas fa-file-alt"></i>
                  </div>
                </div>
              </div>

              <div className="test-card reports">
                <div className="test-icon reports-icon">
                  <i className="fas fa-chart-bar"></i>
                </div>
                <div className="test-content">
                  <div className="test-header">
                    <span className="test-title">Báo cáo</span>
                    <span className="test-subtitle">Xem tất cả 3</span>
                  </div>
                  <div className="report-details">
                    <div className="report-location">Boston</div>
                    <div className="report-grade">B</div>
                    <div className="report-number">23.02</div>
                    <div className="emotion-label">Cảm xúc</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Schedule Appointment */}
            <div className="schedule-card">
              <div className="schedule-text">
                <span>Lên lịch cuộc hẹn</span>
                <span>tiếp theo</span>
              </div>
              <button className="add-btn" onClick={handleAddNote}>
                <i className="fas fa-plus"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Control Bar */}
        <div className="bottom-control-bar">
          <div className="control-group">
            <button className="control-icon" onClick={handleLike}><i className="fas fa-heart"></i></button>
            <button className="control-icon" onClick={handleComment}><i className="fas fa-comment"></i></button>
            <button className="control-icon" onClick={handleCopy}><i className="fas fa-copy"></i></button>
            <button className="control-icon" onClick={handleComment}><i className="fas fa-comment-dots"></i></button>
            <button className="control-icon" onClick={() => alert('Mở menu...')}><i className="fas fa-th"></i></button>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}
